module.exports = __webpack_public_path__ + "static/media/logo-brios-cafe.4c861138.webp";